import React, { useEffect, useState } from "react";
import _ from "lodash";
import { renderFormFields } from "../form/FormRenderer";
import ConfigUtils from "../../utils/ConfigUtils";

const SourceReveal = ({
  parentItem,
  handleOption,
  data,
  showing,
  items,
  parentValue,  
  setData
}) => {
  const inputComponents = ConfigUtils.getInputComponents();
  const [activeItems, setActiveItems] = useState([]);
  
  useEffect(() => {
    if (!showing) {
      _.map(activeItems, (item) => {
        handleOption(_.get(item, "ref"), null);
      });
    } else {     

      let aItems = _.filter(items, (item) =>
        _.has(item, "selection")
          ? _.get(item, "selection")
          : _.get(item, "refData") === _.get(data, _.get(parentItem, "ref"))
      );
      let fields = _.map(_.get(aItems[0], "components"), (key) => {
        let f = _.cloneDeep(_.get(inputComponents, "inputComponents")[0].dataFields[0][key]);
        let override = _.get(aItems[0], "override.metadata");
        if (_.includes(JSON.stringify(override), key, false)) {
          let findObj = _.find(override, (over) => _.has(over, key));
          f = Object.assign(f, _.get(findObj, key));
        }
        f.ref = key;
        return f;
      });
      setActiveItems(fields);   
  }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showing, parentValue]);

  if (!showing) {
    return null;
  }
  return (
    <>
      {renderFormFields (
        activeItems,
        handleOption,
        data,
        setData
      )}
    </>
  );
};

SourceReveal.defaultProps = {
    parentItem:{},
    handleOption:(item,key)=>{/*We are sending handleOption function as a default Prop*/},
    data:{},
    showing:false,
    items:[],
    parentValue:null,    
    setData:()=>{/*We are sending setData function as a default Prop*/}
};

export default SourceReveal;
